import React from 'react';
import { FlexBox } from 'ws-react-flex-layout';

const NotFound = () =>
    <FlexBox
        row="center center"
        className="title-page-primary not-found"
    >
        <FlexBox column="center center">
            404 страница не найдена
        </FlexBox>
    </FlexBox>;

export default NotFound;
